module.exports = __webpack_public_path__ + "img/bank2.8cdefe4e.jpg";